import { injectFeatureFlagInit } from 'helpers/featureFlag';
import { withSentryIdentitySetup } from 'helpers/sentry';
import { Alerts } from './components/common';
import {
  ChurnZeroPageTracking,
  LoadChurnScript,
  LoadUserPilotScript,
  LoadHubspotScript,
} from './components/LoadScripts';
import { Routing } from './Routing';

const AppBase = () => (
  <>
    <Routing />
    <Alerts />
    <LoadChurnScript />
    <ChurnZeroPageTracking />
    <LoadUserPilotScript />
    <LoadHubspotScript />
  </>
);

export const App = withSentryIdentitySetup(injectFeatureFlagInit(AppBase));
